<template>
  <div class="main_content">
    <div class="breadcrumbs" />
    <div class="home">
      <HomeVideo
        v-if="!noCameraFound && routeName == 'home'"
        class="home_video"
        @onTimestampChange="homeTimestamp = $event"
        @onSetTimeRange="homeTimerange = $event"
      />

      <empty-home-video v-if="noCameraFound" />
      <MultiCam v-if="routeName == 'multi-camera'" class="home_video" />
      <Clip v-if="routeName == 'clip'" />
      <HomeEvents
        v-if="routeName == 'home' && showEvents"
        :home-timestamp="homeTimestamp"
        :home-timerange="homeTimerange"
        class="home_events"
      />
      <clip-detail v-if="routeName === 'clip-detail'" />
    </div>
  </div>
</template>

<script>
import HomeEvents from './home/HomeEvents.vue';
import HomeVideo from './home/HomeVideo.vue';
import MultiCam from './events/MultiCam.vue';
import Clip from './clip/Clip.vue';
import ClipDetail from './clip/ClipDetail.vue';
import { mapState, mapGetters } from 'vuex';
import EmptyHomeVideo from './home/EmptyHomeVideo.vue';
import dayjs from 'dayjs';

export default {
  name: 'Home',
  components: {
    HomeEvents,
    HomeVideo,
    MultiCam,
    Clip,
    ClipDetail,
    EmptyHomeVideo,
  },
  data() {
    return {
      homeTimestamp: dayjs().valueOf(),
      homeTimerange: 1,
    };
  },
  computed: {
    ...mapGetters('common', ['currentGroupCamList']),

    ...mapState({
      currentCameraPolicy: (state) => state.common.currentCameraPolicy,
      currentHomeGroup: (state) => state.common.currentHomeGroup,
      homeCameraGroups: (state) => state.common.homeCameraGroups,
      isCurrentAvatarOwner: (state) => state.settings.isCurrentAvatarOwner,
    }),
    routeName() {
      return this.$route.name;
    },
    showEvents() {
      return (
        (this.isCurrentAvatarOwner || !this.currentCameraPolicy.liveOnly) &&
        !this.noCameraFound
      );
    },
    noCameraFound() {
      return !this.currentGroupCamList?.length;
    },
  },
};
</script>

<style lang="scss">
.home {
  display: flex;
  justify-content: space-between;
  flex: 1;
  max-height: 100%;
  &_video {
    flex-grow: 1;
    margin-right: 32px;
  }
  &_events {
    display: flex;
    flex-direction: column;
    width: 330px;
    flex-grow: 0;
    flex-shrink: 0;
  }
}
</style>
